export default __webpack_public_path__ + "static/6d223b845a4fb0441948cc9907db5180.png";